import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { AdminProvider } from './context/AdminContext';
import { Toaster } from './components/ui/sonner';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { LiveSalePopup } from './components/LiveSalePopup';
import { Home } from './pages/Home';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { Orders } from './pages/Orders';
import { TrackOrder } from './pages/TrackOrder';
import { BulkInquiry } from './pages/BulkInquiry';
import { Wishlist } from './pages/Wishlist';
import { Login } from './pages/Login';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <AdminProvider>
          <BrowserRouter>
            <div className="App">
              <Routes>
                {/* Admin Routes (secret path) */}
                <Route path="/boss/login" element={<AdminLogin />} />
                <Route path="/boss/dashboard" element={<AdminDashboard />} />
                {/* Decoy: anyone trying /admin/* silently goes home */}
                <Route path="/admin" element={<Navigate to="/" replace />} />
                <Route path="/admin/*" element={<Navigate to="/" replace />} />
                
                {/* Public Routes with Layout */}
                <Route path="/*" element={
                  <>
                    <Navbar />
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/products" element={<Products />} />
                      <Route path="/products/:id" element={<ProductDetail />} />
                      <Route path="/cart" element={<Cart />} />
                      <Route path="/checkout" element={<Checkout />} />
                      <Route path="/orders" element={<Orders />} />
                      <Route path="/track-order" element={<TrackOrder />} />
                      <Route path="/bulk-inquiry" element={<BulkInquiry />} />
                      <Route path="/wishlist" element={<Wishlist />} />
                      <Route path="/login" element={<Login />} />
                    </Routes>
                    <Footer />
                    <FloatingWhatsApp />
                    <LiveSalePopup />
                  </>
                } />
              </Routes>
              <Toaster position="bottom-left" />
            </div>
          </BrowserRouter>
        </AdminProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
